import { GrowthDataSet } from '../../types/data-set.types';

export const whoBoysWeightForLength0to2: GrowthDataSet = {
  id: 'who-boys-weight-for-length-0-2',
  source: 'WHO',
  title: 'Weight-for-length (Boys, Birth to 2 years)',
  gender: 'male',
  measurementType: 'weight_for_length',
  lengthRange: {
    min: 45,
    max: 110,
  },
  displayUnit: 'kg',
  dataPoints: [
    {
      length: 45,
      m: 2.441,
      s: 0.09182,
      percentiles: {
        p1: 2,
        p3: 2.1,
        p5: 2.1,
        p15: 2.2,
        p25: 2.3,
        p50: 2.4,
        p75: 2.6,
        p85: 2.7,
        p95: 2.9,
        p97: 2.9,
        p99: 3,
      },
    },
    {
      length: 45.5,
      m: 2.5244,
      s: 0.09153,
      percentiles: {
        p1: 2.1,
        p3: 2.1,
        p5: 2.2,
        p15: 2.3,
        p25: 2.4,
        p50: 2.5,
        p75: 2.7,
        p85: 2.8,
        p95: 2.9,
        p97: 3,
        p99: 3.1,
      },
    },
    {
      length: 46,
      m: 2.6077,
      s: 0.09124,
      percentiles: {
        p1: 2.1,
        p3: 2.2,
        p5: 2.3,
        p15: 2.4,
        p25: 2.5,
        p50: 2.6,
        p75: 2.8,
        p85: 2.9,
        p95: 3,
        p97: 3.1,
        p99: 3.3,
      },
    },
    {
      length: 46.5,
      m: 2.6913,
      s: 0.09094,
      percentiles: {
        p1: 2.2,
        p3: 2.3,
        p5: 2.3,
        p15: 2.5,
        p25: 2.5,
        p50: 2.7,
        p75: 2.9,
        p85: 3,
        p95: 3.1,
        p97: 3.2,
        p99: 3.4,
      },
    },
    {
      length: 47,
      m: 2.7755,
      s: 0.09065,
      percentiles: {
        p1: 2.3,
        p3: 2.4,
        p5: 2.4,
        p15: 2.5,
        p25: 2.6,
        p50: 2.8,
        p75: 3,
        p85: 3.1,
        p95: 3.2,
        p97: 3.3,
        p99: 3.5,
      },
    },
    {
      length: 47.5,
      m: 2.8609,
      s: 0.09036,
      percentiles: {
        p1: 2.3,
        p3: 2.4,
        p5: 2.5,
        p15: 2.6,
        p25: 2.7,
        p50: 2.9,
        p75: 3,
        p85: 3.1,
        p95: 3.3,
        p97: 3.4,
        p99: 3.6,
      },
    },
    {
      length: 48,
      m: 2.948,
      s: 0.09007,
      percentiles: {
        p1: 2.4,
        p3: 2.5,
        p5: 2.6,
        p15: 2.7,
        p25: 2.8,
        p50: 2.9,
        p75: 3.1,
        p85: 3.2,
        p95: 3.4,
        p97: 3.5,
        p99: 3.7,
      },
    },
    {
      length: 48.5,
      m: 3.0377,
      s: 0.08977,
      percentiles: {
        p1: 2.5,
        p3: 2.6,
        p5: 2.6,
        p15: 2.8,
        p25: 2.9,
        p50: 3,
        p75: 3.2,
        p85: 3.3,
        p95: 3.5,
        p97: 3.6,
        p99: 3.8,
      },
    },
    {
      length: 49,
      m: 3.1308,
      s: 0.08948,
      percentiles: {
        p1: 2.6,
        p3: 2.7,
        p5: 2.7,
        p15: 2.9,
        p25: 2.9,
        p50: 3.1,
        p75: 3.3,
        p85: 3.4,
        p95: 3.6,
        p97: 3.7,
        p99: 3.9,
      },
    },
    {
      length: 49.5,
      m: 3.2276,
      s: 0.08919,
      percentiles: {
        p1: 2.6,
        p3: 2.7,
        p5: 2.8,
        p15: 2.9,
        p25: 3,
        p50: 3.2,
        p75: 3.4,
        p85: 3.5,
        p95: 3.8,
        p97: 3.8,
        p99: 4,
      },
    },
    {
      length: 50,
      m: 3.3278,
      s: 0.0889,
      percentiles: {
        p1: 2.7,
        p3: 2.8,
        p5: 2.9,
        p15: 3,
        p25: 3.1,
        p50: 3.3,
        p75: 3.5,
        p85: 3.7,
        p95: 3.9,
        p97: 4,
        p99: 4.1,
      },
    },
    {
      length: 50.5,
      m: 3.4311,
      s: 0.08861,
      percentiles: {
        p1: 2.8,
        p3: 2.9,
        p5: 3,
        p15: 3.1,
        p25: 3.2,
        p50: 3.4,
        p75: 3.6,
        p85: 3.8,
        p95: 4,
        p97: 4.1,
        p99: 4.2,
      },
    },
    {
      length: 51,
      m: 3.5376,
      s: 0.08831,
      percentiles: {
        p1: 2.9,
        p3: 3,
        p5: 3.1,
        p15: 3.2,
        p25: 3.3,
        p50: 3.5,
        p75: 3.8,
        p85: 3.9,
        p95: 4.1,
        p97: 4.2,
        p99: 4.4,
      },
    },
    {
      length: 51.5,
      m: 3.6477,
      s: 0.08801,
      percentiles: {
        p1: 3,
        p3: 3.1,
        p5: 3.2,
        p15: 3.3,
        p25: 3.4,
        p50: 3.6,
        p75: 3.9,
        p85: 4,
        p95: 4.2,
        p97: 4.3,
        p99: 4.5,
      },
    },
    {
      length: 52,
      m: 3.762,
      s: 0.08771,
      percentiles: {
        p1: 3.1,
        p3: 3.2,
        p5: 3.3,
        p15: 3.4,
        p25: 3.5,
        p50: 3.8,
        p75: 4,
        p85: 4.1,
        p95: 4.4,
        p97: 4.5,
        p99: 4.6,
      },
    },
    {
      length: 52.5,
      m: 3.8814,
      s: 0.08741,
      percentiles: {
        p1: 3.2,
        p3: 3.3,
        p5: 3.4,
        p15: 3.6,
        p25: 3.7,
        p50: 3.9,
        p75: 4.1,
        p85: 4.3,
        p95: 4.5,
        p97: 4.6,
        p99: 4.8,
      },
    },
    {
      length: 53,
      m: 4.006,
      s: 0.08711,
      percentiles: {
        p1: 3.3,
        p3: 3.4,
        p5: 3.5,
        p15: 3.7,
        p25: 3.8,
        p50: 4,
        p75: 4.3,
        p85: 4.4,
        p95: 4.6,
        p97: 4.7,
        p99: 4.9,
      },
    },
    {
      length: 53.5,
      m: 4.1354,
      s: 0.08681,
      percentiles: {
        p1: 3.4,
        p3: 3.5,
        p5: 3.6,
        p15: 3.8,
        p25: 3.9,
        p50: 4.1,
        p75: 4.4,
        p85: 4.5,
        p95: 4.8,
        p97: 4.9,
        p99: 5.1,
      },
    },
    {
      length: 54,
      m: 4.2693,
      s: 0.08651,
      percentiles: {
        p1: 3.5,
        p3: 3.6,
        p5: 3.7,
        p15: 3.9,
        p25: 4,
        p50: 4.3,
        p75: 4.5,
        p85: 4.7,
        p95: 4.9,
        p97: 5,
        p99: 5.3,
      },
    },
    {
      length: 54.5,
      m: 4.4066,
      s: 0.08621,
      percentiles: {
        p1: 3.6,
        p3: 3.8,
        p5: 3.8,
        p15: 4,
        p25: 4.2,
        p50: 4.4,
        p75: 4.7,
        p85: 4.8,
        p95: 5.1,
        p97: 5.2,
        p99: 5.4,
      },
    },
    {
      length: 55,
      m: 4.5467,
      s: 0.08592,
      percentiles: {
        p1: 3.7,
        p3: 3.9,
        p5: 4,
        p15: 4.2,
        p25: 4.3,
        p50: 4.5,
        p75: 4.8,
        p85: 5,
        p95: 5.3,
        p97: 5.4,
        p99: 5.6,
      },
    },
    {
      length: 55.5,
      m: 4.6892,
      s: 0.08563,
      percentiles: {
        p1: 3.9,
        p3: 4,
        p5: 4.1,
        p15: 4.3,
        p25: 4.4,
        p50: 4.7,
        p75: 5,
        p85: 5.1,
        p95: 5.4,
        p97: 5.5,
        p99: 5.8,
      },
    },
    {
      length: 56,
      m: 4.8338,
      s: 0.08535,
      percentiles: {
        p1: 4,
        p3: 4.1,
        p5: 4.2,
        p15: 4.4,
        p25: 4.6,
        p50: 4.8,
        p75: 5.1,
        p85: 5.3,
        p95: 5.6,
        p97: 5.7,
        p99: 5.9,
      },
    },
    {
      length: 56.5,
      m: 4.9796,
      s: 0.08507,
      percentiles: {
        p1: 4.1,
        p3: 4.3,
        p5: 4.3,
        p15: 4.6,
        p25: 4.7,
        p50: 5,
        p75: 5.3,
        p85: 5.4,
        p95: 5.7,
        p97: 5.9,
        p99: 6.1,
      },
    },
    {
      length: 57,
      m: 5.1259,
      s: 0.08481,
      percentiles: {
        p1: 4.2,
        p3: 4.4,
        p5: 4.5,
        p15: 4.7,
        p25: 4.8,
        p50: 5.1,
        p75: 5.4,
        p85: 5.6,
        p95: 5.9,
        p97: 6,
        p99: 6.3,
      },
    },
    {
      length: 57.5,
      m: 5.2721,
      s: 0.08455,
      percentiles: {
        p1: 4.4,
        p3: 4.5,
        p5: 4.6,
        p15: 4.8,
        p25: 5,
        p50: 5.3,
        p75: 5.6,
        p85: 5.8,
        p95: 6.1,
        p97: 6.2,
        p99: 6.5,
      },
    },
    {
      length: 58,
      m: 5.418,
      s: 0.0843,
      percentiles: {
        p1: 4.5,
        p3: 4.6,
        p5: 4.7,
        p15: 5,
        p25: 5.1,
        p50: 5.4,
        p75: 5.7,
        p85: 5.9,
        p95: 6.2,
        p97: 6.4,
        p99: 6.6,
      },
    },
    {
      length: 58.5,
      m: 5.5632,
      s: 0.08406,
      percentiles: {
        p1: 4.6,
        p3: 4.8,
        p5: 4.9,
        p15: 5.1,
        p25: 5.3,
        p50: 5.6,
        p75: 5.9,
        p85: 6.1,
        p95: 6.4,
        p97: 6.5,
        p99: 6.8,
      },
    },
    {
      length: 59,
      m: 5.7074,
      s: 0.08383,
      percentiles: {
        p1: 4.7,
        p3: 4.9,
        p5: 5,
        p15: 5.2,
        p25: 5.4,
        p50: 5.7,
        p75: 6,
        p85: 6.2,
        p95: 6.6,
        p97: 6.7,
        p99: 7,
      },
    },
    {
      length: 59.5,
      m: 5.8501,
      s: 0.08362,
      percentiles: {
        p1: 4.8,
        p3: 5,
        p5: 5.1,
        p15: 5.4,
        p25: 5.5,
        p50: 5.9,
        p75: 6.2,
        p85: 6.4,
        p95: 6.7,
        p97: 6.9,
        p99: 7.2,
      },
    },
    {
      length: 60,
      m: 5.9907,
      s: 0.08342,
      percentiles: {
        p1: 5,
        p3: 5.1,
        p5: 5.2,
        p15: 5.5,
        p25: 5.7,
        p50: 6,
        p75: 6.3,
        p85: 6.5,
        p95: 6.9,
        p97: 7,
        p99: 7.3,
      },
    },
    {
      length: 60.5,
      m: 6.1284,
      s: 0.08324,
      percentiles: {
        p1: 5.1,
        p3: 5.3,
        p5: 5.4,
        p15: 5.6,
        p25: 5.8,
        p50: 6.1,
        p75: 6.5,
        p85: 6.7,
        p95: 7.1,
        p97: 7.2,
        p99: 7.5,
      },
    },
    {
      length: 61,
      m: 6.2632,
      s: 0.08308,
      percentiles: {
        p1: 5.2,
        p3: 5.4,
        p5: 5.5,
        p15: 5.8,
        p25: 5.9,
        p50: 6.3,
        p75: 6.6,
        p85: 6.8,
        p95: 7.2,
        p97: 7.4,
        p99: 7.7,
      },
    },
    {
      length: 61.5,
      m: 6.3954,
      s: 0.08292,
      percentiles: {
        p1: 5.3,
        p3: 5.5,
        p5: 5.6,
        p15: 5.9,
        p25: 6.1,
        p50: 6.4,
        p75: 6.8,
        p85: 7,
        p95: 7.4,
        p97: 7.5,
        p99: 7.8,
      },
    },
    {
      length: 62,
      m: 6.5251,
      s: 0.08279,
      percentiles: {
        p1: 5.4,
        p3: 5.6,
        p5: 5.7,
        p15: 6,
        p25: 6.2,
        p50: 6.5,
        p75: 6.9,
        p85: 7.1,
        p95: 7.5,
        p97: 7.7,
        p99: 8,
      },
    },
    {
      length: 62.5,
      m: 6.6527,
      s: 0.08266,
      percentiles: {
        p1: 5.5,
        p3: 5.7,
        p5: 5.8,
        p15: 6.1,
        p25: 6.3,
        p50: 6.7,
        p75: 7,
        p85: 7.3,
        p95: 7.6,
        p97: 7.8,
        p99: 8.1,
      },
    },
    {
      length: 63,
      m: 6.7786,
      s: 0.08255,
      percentiles: {
        p1: 5.6,
        p3: 5.8,
        p5: 5.9,
        p15: 6.2,
        p25: 6.4,
        p50: 6.8,
        p75: 7.2,
        p85: 7.4,
        p95: 7.8,
        p97: 8,
        p99: 8.3,
      },
    },
    {
      length: 63.5,
      m: 6.9028,
      s: 0.08245,
      percentiles: {
        p1: 5.7,
        p3: 5.9,
        p5: 6,
        p15: 6.3,
        p25: 6.5,
        p50: 6.9,
        p75: 7.3,
        p85: 7.5,
        p95: 7.9,
        p97: 8.1,
        p99: 8.4,
      },
    },
    {
      length: 64,
      m: 7.0255,
      s: 0.08236,
      percentiles: {
        p1: 5.8,
        p3: 6,
        p5: 6.2,
        p15: 6.5,
        p25: 6.6,
        p50: 7,
        p75: 7.4,
        p85: 7.7,
        p95: 8.1,
        p97: 8.2,
        p99: 8.6,
      },
    },
    {
      length: 64.5,
      m: 7.1467,
      s: 0.08229,
      percentiles: {
        p1: 5.9,
        p3: 6.1,
        p5: 6.3,
        p15: 6.6,
        p25: 6.8,
        p50: 7.1,
        p75: 7.6,
        p85: 7.8,
        p95: 8.2,
        p97: 8.4,
        p99: 8.7,
      },
    },
    {
      length: 65,
      m: 7.2666,
      s: 0.08223,
      percentiles: {
        p1: 6,
        p3: 6.3,
        p5: 6.4,
        p15: 6.7,
        p25: 6.9,
        p50: 7.3,
        p75: 7.7,
        p85: 7.9,
        p95: 8.3,
        p97: 8.5,
        p99: 8.9,
      },
    },
    {
      length: 65.5,
      m: 7.3854,
      s: 0.08218,
      percentiles: {
        p1: 6.1,
        p3: 6.4,
        p5: 6.5,
        p15: 6.8,
        p25: 7,
        p50: 7.4,
        p75: 7.8,
        p85: 8.1,
        p95: 8.5,
        p97: 8.7,
        p99: 9,
      },
    },
    {
      length: 66,
      m: 7.5034,
      s: 0.08215,
      percentiles: {
        p1: 6.2,
        p3: 6.5,
        p5: 6.6,
        p15: 6.9,
        p25: 7.1,
        p50: 7.5,
        p75: 7.9,
        p85: 8.2,
        p95: 8.6,
        p97: 8.8,
        p99: 9.1,
      },
    },
    {
      length: 66.5,
      m: 7.6206,
      s: 0.08213,
      percentiles: {
        p1: 6.3,
        p3: 6.6,
        p5: 6.7,
        p15: 7,
        p25: 7.2,
        p50: 7.6,
        p75: 8.1,
        p85: 8.3,
        p95: 8.8,
        p97: 8.9,
        p99: 9.3,
      },
    },
    {
      length: 67,
      m: 7.737,
      s: 0.08212,
      percentiles: {
        p1: 6.4,
        p3: 6.7,
        p5: 6.8,
        p15: 7.1,
        p25: 7.3,
        p50: 7.7,
        p75: 8.2,
        p85: 8.4,
        p95: 8.9,
        p97: 9.1,
        p99: 9.4,
      },
    },
    {
      length: 67.5,
      m: 7.8526,
      s: 0.08212,
      percentiles: {
        p1: 6.5,
        p3: 6.8,
        p5: 6.9,
        p15: 7.2,
        p25: 7.4,
        p50: 7.9,
        p75: 8.3,
        p85: 8.6,
        p95: 9,
        p97: 9.2,
        p99: 9.6,
      },
    },
    {
      length: 68,
      m: 7.9674,
      s: 0.08214,
      percentiles: {
        p1: 6.6,
        p3: 6.9,
        p5: 7,
        p15: 7.3,
        p25: 7.5,
        p50: 8,
        p75: 8.4,
        p85: 8.7,
        p95: 9.2,
        p97: 9.3,
        p99: 9.7,
      },
    },
    {
      length: 68.5,
      m: 8.0816,
      s: 0.08216,
      percentiles: {
        p1: 6.7,
        p3: 7,
        p5: 7.1,
        p15: 7.4,
        p25: 7.7,
        p50: 8.1,
        p75: 8.5,
        p85: 8.8,
        p95: 9.3,
        p97: 9.5,
        p99: 9.8,
      },
    },
    {
      length: 69,
      m: 8.1955,
      s: 0.08219,
      percentiles: {
        p1: 6.8,
        p3: 7.1,
        p5: 7.2,
        p15: 7.5,
        p25: 7.8,
        p50: 8.2,
        p75: 8.7,
        p85: 8.9,
        p95: 9.4,
        p97: 9.6,
        p99: 10,
      },
    },
    {
      length: 69.5,
      m: 8.3092,
      s: 0.08224,
      percentiles: {
        p1: 6.9,
        p3: 7.1,
        p5: 7.3,
        p15: 7.6,
        p25: 7.9,
        p50: 8.3,
        p75: 8.8,
        p85: 9.1,
        p95: 9.5,
        p97: 9.7,
        p99: 10.1,
      },
    },
    {
      length: 70,
      m: 8.4227,
      s: 0.08229,
      percentiles: {
        p1: 7,
        p3: 7.2,
        p5: 7.4,
        p15: 7.7,
        p25: 8,
        p50: 8.4,
        p75: 8.9,
        p85: 9.2,
        p95: 9.7,
        p97: 9.9,
        p99: 10.3,
      },
    },
    {
      length: 70.5,
      m: 8.5358,
      s: 0.08235,
      percentiles: {
        p1: 7.1,
        p3: 7.3,
        p5: 7.5,
        p15: 7.8,
        p25: 8.1,
        p50: 8.5,
        p75: 9,
        p85: 9.3,
        p95: 9.8,
        p97: 10,
        p99: 10.4,
      },
    },
    {
      length: 71,
      m: 8.648,
      s: 0.08241,
      percentiles: {
        p1: 7.2,
        p3: 7.4,
        p5: 7.6,
        p15: 8,
        p25: 8.2,
        p50: 8.6,
        p75: 9.1,
        p85: 9.4,
        p95: 9.9,
        p97: 10.1,
        p99: 10.5,
      },
    },
    {
      length: 71.5,
      m: 8.7594,
      s: 0.08248,
      percentiles: {
        p1: 7.3,
        p3: 7.5,
        p5: 7.7,
        p15: 8.1,
        p25: 8.3,
        p50: 8.8,
        p75: 9.3,
        p85: 9.6,
        p95: 10.1,
        p97: 10.3,
        p99: 10.7,
      },
    },
    {
      length: 72,
      m: 8.8697,
      s: 0.08254,
      percentiles: {
        p1: 7.4,
        p3: 7.6,
        p5: 7.8,
        p15: 8.2,
        p25: 8.4,
        p50: 8.9,
        p75: 9.4,
        p85: 9.7,
        p95: 10.2,
        p97: 10.4,
        p99: 10.8,
      },
    },
    {
      length: 72.5,
      m: 8.9788,
      s: 0.08262,
      percentiles: {
        p1: 7.5,
        p3: 7.7,
        p5: 7.9,
        p15: 8.3,
        p25: 8.5,
        p50: 9,
        p75: 9.5,
        p85: 9.8,
        p95: 10.3,
        p97: 10.5,
        p99: 11,
      },
    },
    {
      length: 73,
      m: 9.0865,
      s: 0.08269,
      percentiles: {
        p1: 7.5,
        p3: 7.8,
        p5: 8,
        p15: 8.4,
        p25: 8.6,
        p50: 9.1,
        p75: 9.6,
        p85: 9.9,
        p95: 10.4,
        p97: 10.7,
        p99: 11.1,
      },
    },
    {
      length: 73.5,
      m: 9.1927,
      s: 0.08276,
      percentiles: {
        p1: 7.6,
        p3: 7.9,
        p5: 8,
        p15: 8.4,
        p25: 8.7,
        p50: 9.2,
        p75: 9.7,
        p85: 10,
        p95: 10.6,
        p97: 10.8,
        p99: 11.2,
      },
    },
    {
      length: 74,
      m: 9.2974,
      s: 0.08283,
      percentiles: {
        p1: 7.7,
        p3: 8,
        p5: 8.1,
        p15: 8.5,
        p25: 8.8,
        p50: 9.3,
        p75: 9.8,
        p85: 10.1,
        p95: 10.7,
        p97: 10.9,
        p99: 11.4,
      },
    },
    {
      length: 74.5,
      m: 9.401,
      s: 0.08289,
      percentiles: {
        p1: 7.8,
        p3: 8.1,
        p5: 8.2,
        p15: 8.6,
        p25: 8.9,
        p50: 9.4,
        p75: 9.9,
        p85: 10.3,
        p95: 10.8,
        p97: 11,
        p99: 11.5,
      },
    },
    {
      length: 75,
      m: 9.5032,
      s: 0.08295,
      percentiles: {
        p1: 7.9,
        p3: 8.2,
        p5: 8.3,
        p15: 8.7,
        p25: 9,
        p50: 9.5,
        p75: 10.1,
        p85: 10.4,
        p95: 10.9,
        p97: 11.2,
        p99: 11.6,
      },
    },
    {
      length: 75.5,
      m: 9.6041,
      s: 0.08301,
      percentiles: {
        p1: 8,
        p3: 8.2,
        p5: 8.4,
        p15: 8.8,
        p25: 9.1,
        p50: 9.6,
        p75: 10.2,
        p85: 10.5,
        p95: 11,
        p97: 11.3,
        p99: 11.7,
      },
    },
    {
      length: 76,
      m: 9.7033,
      s: 0.08307,
      percentiles: {
        p1: 8,
        p3: 8.3,
        p5: 8.5,
        p15: 8.9,
        p25: 9.2,
        p50: 9.7,
        p75: 10.3,
        p85: 10.6,
        p95: 11.2,
        p97: 11.4,
        p99: 11.9,
      },
    },
    {
      length: 76.5,
      m: 9.8007,
      s: 0.08311,
      percentiles: {
        p1: 8.1,
        p3: 8.4,
        p5: 8.6,
        p15: 9,
        p25: 9.3,
        p50: 9.8,
        p75: 10.4,
        p85: 10.7,
        p95: 11.3,
        p97: 11.5,
        p99: 12,
      },
    },
    {
      length: 77,
      m: 9.8963,
      s: 0.08314,
      percentiles: {
        p1: 8.2,
        p3: 8.5,
        p5: 8.7,
        p15: 9.1,
        p25: 9.4,
        p50: 9.9,
        p75: 10.5,
        p85: 10.8,
        p95: 11.4,
        p97: 11.6,
        p99: 12.1,
      },
    },
    {
      length: 77.5,
      m: 9.9902,
      s: 0.08317,
      percentiles: {
        p1: 8.3,
        p3: 8.6,
        p5: 8.7,
        p15: 9.2,
        p25: 9.5,
        p50: 10,
        p75: 10.6,
        p85: 10.9,
        p95: 11.5,
        p97: 11.7,
        p99: 12.2,
      },
    },
    {
      length: 78,
      m: 10.0827,
      s: 0.08318,
      percentiles: {
        p1: 8.4,
        p3: 8.7,
        p5: 8.8,
        p15: 9.3,
        p25: 9.5,
        p50: 10.1,
        p75: 10.7,
        p85: 11,
        p95: 11.6,
        p97: 11.8,
        p99: 12.3,
      },
    },
    {
      length: 78.5,
      m: 10.1741,
      s: 0.08318,
      percentiles: {
        p1: 8.4,
        p3: 8.7,
        p5: 8.9,
        p15: 9.3,
        p25: 9.6,
        p50: 10.2,
        p75: 10.8,
        p85: 11.1,
        p95: 11.7,
        p97: 12,
        p99: 12.4,
      },
    },
    {
      length: 79,
      m: 10.2649,
      s: 0.08316,
      percentiles: {
        p1: 8.5,
        p3: 8.8,
        p5: 9,
        p15: 9.4,
        p25: 9.7,
        p50: 10.3,
        p75: 10.9,
        p85: 11.2,
        p95: 11.8,
        p97: 12.1,
        p99: 12.5,
      },
    },
    {
      length: 79.5,
      m: 10.3558,
      s: 0.08313,
      percentiles: {
        p1: 8.6,
        p3: 8.9,
        p5: 9.1,
        p15: 9.5,
        p25: 9.8,
        p50: 10.4,
        p75: 11,
        p85: 11.3,
        p95: 11.9,
        p97: 12.2,
        p99: 12.7,
      },
    },
    {
      length: 80,
      m: 10.4475,
      s: 0.08308,
      percentiles: {
        p1: 8.7,
        p3: 9,
        p5: 9.1,
        p15: 9.6,
        p25: 9.9,
        p50: 10.4,
        p75: 11.1,
        p85: 11.4,
        p95: 12,
        p97: 12.3,
        p99: 12.8,
      },
    },
    {
      length: 80.5,
      m: 10.5405,
      s: 0.08301,
      percentiles: {
        p1: 8.7,
        p3: 9.1,
        p5: 9.2,
        p15: 9.7,
        p25: 10,
        p50: 10.5,
        p75: 11.2,
        p85: 11.5,
        p95: 12.1,
        p97: 12.4,
        p99: 12.9,
      },
    },
    {
      length: 81,
      m: 10.6352,
      s: 0.08293,
      percentiles: {
        p1: 8.8,
        p3: 9.1,
        p5: 9.3,
        p15: 9.8,
        p25: 10.1,
        p50: 10.6,
        p75: 11.3,
        p85: 11.6,
        p95: 12.2,
        p97: 12.5,
        p99: 13,
      },
    },
    {
      length: 81.5,
      m: 10.7322,
      s: 0.08284,
      percentiles: {
        p1: 8.9,
        p3: 9.2,
        p5: 9.4,
        p15: 9.9,
        p25: 10.2,
        p50: 10.7,
        p75: 11.4,
        p85: 11.7,
        p95: 12.3,
        p97: 12.6,
        p99: 13.1,
      },
    },
    {
      length: 82,
      m: 10.8321,
      s: 0.08273,
      percentiles: {
        p1: 9,
        p3: 9.3,
        p5: 9.5,
        p15: 10,
        p25: 10.2,
        p50: 10.8,
        p75: 11.5,
        p85: 11.8,
        p95: 12.5,
        p97: 12.7,
        p99: 13.2,
      },
    },
    {
      length: 82.5,
      m: 10.935,
      s: 0.0826,
      percentiles: {
        p1: 9.1,
        p3: 9.4,
        p5: 9.6,
        p15: 10.1,
        p25: 10.3,
        p50: 10.9,
        p75: 11.6,
        p85: 11.9,
        p95: 12.6,
        p97: 12.8,
        p99: 13.3,
      },
    },
    {
      length: 83,
      m: 11.0415,
      s: 0.08246,
      percentiles: {
        p1: 9.2,
        p3: 9.5,
        p5: 9.7,
        p15: 10.1,
        p25: 10.4,
        p50: 11,
        p75: 11.7,
        p85: 12,
        p95: 12.7,
        p97: 13,
        p99: 13.5,
      },
    },
    {
      length: 83.5,
      m: 11.1516,
      s: 0.08231,
      percentiles: {
        p1: 9.3,
        p3: 9.6,
        p5: 9.8,
        p15: 10.3,
        p25: 10.6,
        p50: 11.2,
        p75: 11.8,
        p85: 12.2,
        p95: 12.8,
        p97: 13.1,
        p99: 13.6,
      },
    },
    {
      length: 84,
      m: 11.2651,
      s: 0.08215,
      percentiles: {
        p1: 9.4,
        p3: 9.7,
        p5: 9.9,
        p15: 10.4,
        p25: 10.7,
        p50: 11.3,
        p75: 11.9,
        p85: 12.3,
        p95: 12.9,
        p97: 13.2,
        p99: 13.7,
      },
    },
    {
      length: 84.5,
      m: 11.3817,
      s: 0.08198,
      percentiles: {
        p1: 9.5,
        p3: 9.8,
        p5: 10,
        p15: 10.5,
        p25: 10.8,
        p50: 11.4,
        p75: 12,
        p85: 12.4,
        p95: 13.1,
        p97: 13.3,
        p99: 13.9,
      },
    },
    {
      length: 85,
      m: 11.5007,
      s: 0.08181,
      percentiles: {
        p1: 9.6,
        p3: 9.9,
        p5: 10.1,
        p15: 10.6,
        p25: 10.9,
        p50: 11.5,
        p75: 12.2,
        p85: 12.5,
        p95: 13.2,
        p97: 13.5,
        p99: 14,
      },
    },
    {
      length: 85.5,
      m: 11.6218,
      s: 0.08163,
      percentiles: {
        p1: 9.7,
        p3: 10,
        p5: 10.2,
        p15: 10.7,
        p25: 11,
        p50: 11.6,
        p75: 12.3,
        p85: 12.7,
        p95: 13.3,
        p97: 13.6,
        p99: 14.1,
      },
    },
    {
      length: 86,
      m: 11.7444,
      s: 0.08145,
      percentiles: {
        p1: 9.8,
        p3: 10.1,
        p5: 10.3,
        p15: 10.8,
        p25: 11.1,
        p50: 11.7,
        p75: 12.4,
        p85: 12.8,
        p95: 13.5,
        p97: 13.7,
        p99: 14.3,
      },
    },
    {
      length: 86.5,
      m: 11.8678,
      s: 0.08128,
      percentiles: {
        p1: 9.9,
        p3: 10.2,
        p5: 10.4,
        p15: 10.9,
        p25: 11.2,
        p50: 11.9,
        p75: 12.5,
        p85: 12.9,
        p95: 13.6,
        p97: 13.9,
        p99: 14.4,
      },
    },
    {
      length: 87,
      m: 11.9916,
      s: 0.08111,
      percentiles: {
        p1: 10,
        p3: 10.3,
        p5: 10.5,
        p15: 11,
        p25: 11.4,
        p50: 12,
        p75: 12.7,
        p85: 13.1,
        p95: 13.7,
        p97: 14,
        p99: 14.6,
      },
    },
    {
      length: 87.5,
      m: 12.1152,
      s: 0.08096,
      percentiles: {
        p1: 10.1,
        p3: 10.4,
        p5: 10.6,
        p15: 11.2,
        p25: 11.5,
        p50: 12.1,
        p75: 12.8,
        p85: 13.2,
        p95: 13.9,
        p97: 14.2,
        p99: 14.7,
      },
    },
    {
      length: 88,
      m: 12.2382,
      s: 0.08082,
      percentiles: {
        p1: 10.2,
        p3: 10.6,
        p5: 10.7,
        p15: 11.3,
        p25: 11.6,
        p50: 12.2,
        p75: 12.9,
        p85: 13.3,
        p95: 14,
        p97: 14.3,
        p99: 14.9,
      },
    },
    {
      length: 88.5,
      m: 12.3603,
      s: 0.08069,
      percentiles: {
        p1: 10.3,
        p3: 10.7,
        p5: 10.9,
        p15: 11.4,
        p25: 11.7,
        p50: 12.4,
        p75: 13.1,
        p85: 13.5,
        p95: 14.2,
        p97: 14.4,
        p99: 15,
      },
    },
    {
      length: 89,
      m: 12.4815,
      s: 0.08058,
      percentiles: {
        p1: 10.4,
        p3: 10.8,
        p5: 11,
        p15: 11.5,
        p25: 11.8,
        p50: 12.5,
        p75: 13.2,
        p85: 13.6,
        p95: 14.3,
        p97: 14.6,
        p99: 15.2,
      },
    },
    {
      length: 89.5,
      m: 12.6017,
      s: 0.08048,
      percentiles: {
        p1: 10.5,
        p3: 10.9,
        p5: 11.1,
        p15: 11.6,
        p25: 11.9,
        p50: 12.6,
        p75: 13.3,
        p85: 13.7,
        p95: 14.4,
        p97: 14.7,
        p99: 15.3,
      },
    },
    {
      length: 90,
      m: 12.7209,
      s: 0.08041,
      percentiles: {
        p1: 10.6,
        p3: 11,
        p5: 11.2,
        p15: 11.7,
        p25: 12.1,
        p50: 12.7,
        p75: 13.4,
        p85: 13.8,
        p95: 14.6,
        p97: 14.9,
        p99: 15.4,
      },
    },
    {
      length: 90.5,
      m: 12.8392,
      s: 0.08034,
      percentiles: {
        p1: 10.7,
        p3: 11.1,
        p5: 11.3,
        p15: 11.8,
        p25: 12.2,
        p50: 12.8,
        p75: 13.6,
        p85: 14,
        p95: 14.7,
        p97: 15,
        p99: 15.6,
      },
    },
    {
      length: 91,
      m: 12.9569,
      s: 0.0803,
      percentiles: {
        p1: 10.8,
        p3: 11.2,
        p5: 11.4,
        p15: 11.9,
        p25: 12.3,
        p50: 13,
        p75: 13.7,
        p85: 14.1,
        p95: 14.8,
        p97: 15.1,
        p99: 15.7,
      },
    },
    {
      length: 91.5,
      m: 13.0742,
      s: 0.08026,
      percentiles: {
        p1: 10.9,
        p3: 11.3,
        p5: 11.5,
        p15: 12,
        p25: 12.4,
        p50: 13.1,
        p75: 13.8,
        p85: 14.2,
        p95: 15,
        p97: 15.3,
        p99: 15.9,
      },
    },
    {
      length: 92,
      m: 13.191,
      s: 0.08025,
      percentiles: {
        p1: 11,
        p3: 11.4,
        p5: 11.6,
        p15: 12.2,
        p25: 12.5,
        p50: 13.2,
        p75: 13.9,
        p85: 14.4,
        p95: 15.1,
        p97: 15.4,
        p99: 16,
      },
    },
    {
      length: 92.5,
      m: 13.3075,
      s: 0.08025,
      percentiles: {
        p1: 11.1,
        p3: 11.5,
        p5: 11.7,
        p15: 12.3,
        p25: 12.6,
        p50: 13.3,
        p75: 14.1,
        p85: 14.5,
        p95: 15.2,
        p97: 15.5,
        p99: 16.1,
      },
    },
    {
      length: 93,
      m: 13.4239,
      s: 0.08026,
      percentiles: {
        p1: 11.2,
        p3: 11.6,
        p5: 11.8,
        p15: 12.4,
        p25: 12.7,
        p50: 13.4,
        p75: 14.2,
        p85: 14.6,
        p95: 15.4,
        p97: 15.7,
        p99: 16.3,
      },
    },
    {
      length: 93.5,
      m: 13.5404,
      s: 0.08029,
      percentiles: {
        p1: 11.3,
        p3: 11.7,
        p5: 11.9,
        p15: 12.5,
        p25: 12.8,
        p50: 13.5,
        p75: 14.3,
        p85: 14.7,
        p95: 15.5,
        p97: 15.8,
        p99: 16.4,
      },
    },
    {
      length: 94,
      m: 13.6572,
      s: 0.08034,
      percentiles: {
        p1: 11.4,
        p3: 11.8,
        p5: 12,
        p15: 12.6,
        p25: 12.9,
        p50: 13.7,
        p75: 14.4,
        p85: 14.9,
        p95: 15.6,
        p97: 16,
        p99: 16.6,
      },
    },
    {
      length: 94.5,
      m: 13.7746,
      s: 0.0804,
      percentiles: {
        p1: 11.5,
        p3: 11.9,
        p5: 12.1,
        p15: 12.7,
        p25: 13.1,
        p50: 13.8,
        p75: 14.5,
        p85: 15,
        p95: 15.8,
        p97: 16.1,
        p99: 16.7,
      },
    },
    {
      length: 95,
      m: 13.8928,
      s: 0.08047,
      percentiles: {
        p1: 11.6,
        p3: 12,
        p5: 12.2,
        p15: 12.8,
        p25: 13.2,
        p50: 13.9,
        p75: 14.7,
        p85: 15.1,
        p95: 15.9,
        p97: 16.2,
        p99: 16.9,
      },
    },
    {
      length: 95.5,
      m: 14.012,
      s: 0.08056,
      percentiles: {
        p1: 11.7,
        p3: 12.1,
        p5: 12.3,
        p15: 12.9,
        p25: 13.3,
        p50: 14,
        p75: 14.8,
        p85: 15.3,
        p95: 16,
        p97: 16.4,
        p99: 17,
      },
    },
    {
      length: 96,
      m: 14.1325,
      s: 0.08067,
      percentiles: {
        p1: 11.8,
        p3: 12.2,
        p5: 12.4,
        p15: 13,
        p25: 13.4,
        p50: 14.1,
        p75: 14.9,
        p85: 15.4,
        p95: 16.2,
        p97: 16.5,
        p99: 17.2,
      },
    },
    {
      length: 96.5,
      m: 14.2544,
      s: 0.08078,
      percentiles: {
        p1: 11.9,
        p3: 12.3,
        p5: 12.5,
        p15: 13.1,
        p25: 13.5,
        p50: 14.3,
        p75: 15.1,
        p85: 15.5,
        p95: 16.3,
        p97: 16.7,
        p99: 17.3,
      },
    },
    {
      length: 97,
      m: 14.3782,
      s: 0.08092,
      percentiles: {
        p1: 12,
        p3: 12.4,
        p5: 12.6,
        p15: 13.2,
        p25: 13.6,
        p50: 14.4,
        p75: 15.2,
        p85: 15.7,
        p95: 16.5,
        p97: 16.8,
        p99: 17.5,
      },
    },
    {
      length: 97.5,
      m: 14.5038,
      s: 0.08106,
      percentiles: {
        p1: 12.1,
        p3: 12.5,
        p5: 12.7,
        p15: 13.4,
        p25: 13.7,
        p50: 14.5,
        p75: 15.3,
        p85: 15.8,
        p95: 16.6,
        p97: 17,
        p99: 17.6,
      },
    },
    {
      length: 98,
      m: 14.6316,
      s: 0.08122,
      percentiles: {
        p1: 12.2,
        p3: 12.6,
        p5: 12.8,
        p15: 13.5,
        p25: 13.9,
        p50: 14.6,
        p75: 15.5,
        p85: 15.9,
        p95: 16.8,
        p97: 17.1,
        p99: 17.8,
      },
    },
    {
      length: 98.5,
      m: 14.7614,
      s: 0.08139,
      percentiles: {
        p1: 12.3,
        p3: 12.7,
        p5: 13,
        p15: 13.6,
        p25: 14,
        p50: 14.8,
        p75: 15.6,
        p85: 16.1,
        p95: 16.9,
        p97: 17.3,
        p99: 18,
      },
    },
    {
      length: 99,
      m: 14.8934,
      s: 0.08157,
      percentiles: {
        p1: 12.4,
        p3: 12.8,
        p5: 13.1,
        p15: 13.7,
        p25: 14.1,
        p50: 14.9,
        p75: 15.7,
        p85: 16.2,
        p95: 17.1,
        p97: 17.4,
        p99: 18.1,
      },
    },
    {
      length: 99.5,
      m: 15.0275,
      s: 0.08177,
      percentiles: {
        p1: 12.5,
        p3: 12.9,
        p5: 13.2,
        p15: 13.8,
        p25: 14.2,
        p50: 15,
        p75: 15.9,
        p85: 16.4,
        p95: 17.2,
        p97: 17.6,
        p99: 18.3,
      },
    },
    {
      length: 100,
      m: 15.1637,
      s: 0.08198,
      percentiles: {
        p1: 12.6,
        p3: 13,
        p5: 13.3,
        p15: 13.9,
        p25: 14.4,
        p50: 15.2,
        p75: 16,
        p85: 16.5,
        p95: 17.4,
        p97: 17.8,
        p99: 18.5,
      },
    },
    {
      length: 100.5,
      m: 15.3018,
      s: 0.0822,
      percentiles: {
        p1: 12.7,
        p3: 13.2,
        p5: 13.4,
        p15: 14.1,
        p25: 14.5,
        p50: 15.3,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 17.9,
        p99: 18.7,
      },
    },
    {
      length: 101,
      m: 15.4419,
      s: 0.08243,
      percentiles: {
        p1: 12.8,
        p3: 13.3,
        p5: 13.5,
        p15: 14.2,
        p25: 14.6,
        p50: 15.4,
        p75: 16.3,
        p85: 16.8,
        p95: 17.7,
        p97: 18.1,
        p99: 18.8,
      },
    },
    {
      length: 101.5,
      m: 15.5838,
      s: 0.08267,
      percentiles: {
        p1: 12.9,
        p3: 13.4,
        p5: 13.6,
        p15: 14.3,
        p25: 14.7,
        p50: 15.6,
        p75: 16.5,
        p85: 17,
        p95: 17.9,
        p97: 18.3,
        p99: 19,
      },
    },
    {
      length: 102,
      m: 15.7276,
      s: 0.08292,
      percentiles: {
        p1: 13,
        p3: 13.5,
        p5: 13.8,
        p15: 14.5,
        p25: 14.9,
        p50: 15.7,
        p75: 16.6,
        p85: 17.2,
        p95: 18.1,
        p97: 18.5,
        p99: 19.2,
      },
    },
    {
      length: 102.5,
      m: 15.8732,
      s: 0.08317,
      percentiles: {
        p1: 13.2,
        p3: 13.6,
        p5: 13.9,
        p15: 14.6,
        p25: 15,
        p50: 15.9,
        p75: 16.8,
        p85: 17.3,
        p95: 18.3,
        p97: 18.6,
        p99: 19.4,
      },
    },
    {
      length: 103,
      m: 16.0206,
      s: 0.08343,
      percentiles: {
        p1: 13.3,
        p3: 13.8,
        p5: 14,
        p15: 14.7,
        p25: 15.2,
        p50: 16,
        p75: 17,
        p85: 17.5,
        p95: 18.4,
        p97: 18.8,
        p99: 19.6,
      },
    },
    {
      length: 103.5,
      m: 16.1697,
      s: 0.0837,
      percentiles: {
        p1: 13.4,
        p3: 13.9,
        p5: 14.1,
        p15: 14.8,
        p25: 15.3,
        p50: 16.2,
        p75: 17.1,
        p85: 17.7,
        p95: 18.6,
        p97: 19,
        p99: 19.8,
      },
    },
    {
      length: 104,
      m: 16.3204,
      s: 0.08397,
      percentiles: {
        p1: 13.5,
        p3: 14,
        p5: 14.3,
        p15: 15,
        p25: 15.4,
        p50: 16.3,
        p75: 17.3,
        p85: 17.8,
        p95: 18.8,
        p97: 19.2,
        p99: 20,
      },
    },
    {
      length: 104.5,
      m: 16.4728,
      s: 0.08425,
      percentiles: {
        p1: 13.6,
        p3: 14.1,
        p5: 14.4,
        p15: 15.1,
        p25: 15.6,
        p50: 16.5,
        p75: 17.4,
        p85: 18,
        p95: 19,
        p97: 19.4,
        p99: 20.2,
      },
    },
    {
      length: 105,
      m: 16.6268,
      s: 0.08453,
      percentiles: {
        p1: 13.7,
        p3: 14.2,
        p5: 14.5,
        p15: 15.3,
        p25: 15.7,
        p50: 16.6,
        p75: 17.6,
        p85: 18.2,
        p95: 19.2,
        p97: 19.6,
        p99: 20.4,
      },
    },
    {
      length: 105.5,
      m: 16.7826,
      s: 0.08481,
      percentiles: {
        p1: 13.9,
        p3: 14.4,
        p5: 14.6,
        p15: 15.4,
        p25: 15.9,
        p50: 16.8,
        p75: 17.8,
        p85: 18.4,
        p95: 19.4,
        p97: 19.8,
        p99: 20.6,
      },
    },
    {
      length: 106,
      m: 16.9401,
      s: 0.0851,
      percentiles: {
        p1: 14,
        p3: 14.5,
        p5: 14.8,
        p15: 15.5,
        p25: 16,
        p50: 16.9,
        p75: 18,
        p85: 18.5,
        p95: 19.6,
        p97: 20,
        p99: 20.8,
      },
    },
    {
      length: 106.5,
      m: 17.0995,
      s: 0.08539,
      percentiles: {
        p1: 14.1,
        p3: 14.6,
        p5: 14.9,
        p15: 15.7,
        p25: 16.2,
        p50: 17.1,
        p75: 18.1,
        p85: 18.7,
        p95: 19.7,
        p97: 20.2,
        p99: 21,
      },
    },
    {
      length: 107,
      m: 17.2607,
      s: 0.08568,
      percentiles: {
        p1: 14.2,
        p3: 14.8,
        p5: 15,
        p15: 15.8,
        p25: 16.3,
        p50: 17.3,
        p75: 18.3,
        p85: 18.9,
        p95: 19.9,
        p97: 20.4,
        p99: 21.2,
      },
    },
    {
      length: 107.5,
      m: 17.4237,
      s: 0.08599,
      percentiles: {
        p1: 14.4,
        p3: 14.9,
        p5: 15.2,
        p15: 16,
        p25: 16.5,
        p50: 17.4,
        p75: 18.5,
        p85: 19.1,
        p95: 20.1,
        p97: 20.6,
        p99: 21.4,
      },
    },
    {
      length: 108,
      m: 17.5885,
      s: 0.08629,
      percentiles: {
        p1: 14.5,
        p3: 15,
        p5: 15.3,
        p15: 16.1,
        p25: 16.6,
        p50: 17.6,
        p75: 18.7,
        p85: 19.3,
        p95: 20.3,
        p97: 20.8,
        p99: 21.7,
      },
    },
    {
      length: 108.5,
      m: 17.7553,
      s: 0.0866,
      percentiles: {
        p1: 14.6,
        p3: 15.2,
        p5: 15.5,
        p15: 16.3,
        p25: 16.8,
        p50: 17.8,
        p75: 18.8,
        p85: 19.5,
        p95: 20.5,
        p97: 21,
        p99: 21.9,
      },
    },
    {
      length: 109,
      m: 17.9242,
      s: 0.08691,
      percentiles: {
        p1: 14.7,
        p3: 15.3,
        p5: 15.6,
        p15: 16.4,
        p25: 16.9,
        p50: 17.9,
        p75: 19,
        p85: 19.6,
        p95: 20.8,
        p97: 21.2,
        p99: 22.1,
      },
    },
    {
      length: 109.5,
      m: 18.0954,
      s: 0.08723,
      percentiles: {
        p1: 14.9,
        p3: 15.4,
        p5: 15.7,
        p15: 16.6,
        p25: 17.1,
        p50: 18.1,
        p75: 19.2,
        p85: 19.8,
        p95: 21,
        p97: 21.4,
        p99: 22.3,
      },
    },
    {
      length: 110,
      m: 18.2689,
      s: 0.08755,
      percentiles: {
        p1: 15,
        p3: 15.6,
        p5: 15.9,
        p15: 16.7,
        p25: 17.2,
        p50: 18.3,
        p75: 19.4,
        p85: 20,
        p95: 21.2,
        p97: 21.6,
        p99: 22.6,
      },
    },
  ],
};

export const whoBoysWeightForLength2to5: GrowthDataSet = {
  id: 'who-boys-weight-for-length-2-5',
  source: 'WHO',
  title: 'Weight-for-length (Boys, 2-5 years)',
  gender: 'male',
  measurementType: 'weight_for_length',
  lengthRange: {
    min: 65,
    max: 120,
  },
  displayUnit: 'kg',
  dataPoints: [
    {
      length: 65,
      m: 7.4327,
      s: 0.08217,
      percentiles: {
        p1: 6.2,
        p3: 6.4,
        p5: 6.5,
        p15: 6.8,
        p25: 7,
        p50: 7.4,
        p75: 7.9,
        p85: 8.1,
        p95: 8.5,
        p97: 8.7,
        p99: 9.1,
      },
    },
    {
      length: 65.5,
      m: 7.5504,
      s: 0.08214,
      percentiles: {
        p1: 6.3,
        p3: 6.5,
        p5: 6.6,
        p15: 6.9,
        p25: 7.1,
        p50: 7.6,
        p75: 8,
        p85: 8.2,
        p95: 8.7,
        p97: 8.9,
        p99: 9.2,
      },
    },
    {
      length: 66,
      m: 7.6673,
      s: 0.08212,
      percentiles: {
        p1: 6.4,
        p3: 6.6,
        p5: 6.7,
        p15: 7.1,
        p25: 7.3,
        p50: 7.7,
        p75: 8.1,
        p85: 8.4,
        p95: 8.8,
        p97: 9,
        p99: 9.3,
      },
    },
    {
      length: 66.5,
      m: 7.7834,
      s: 0.08212,
      percentiles: {
        p1: 6.5,
        p3: 6.7,
        p5: 6.8,
        p15: 7.2,
        p25: 7.4,
        p50: 7.8,
        p75: 8.2,
        p85: 8.5,
        p95: 8.9,
        p97: 9.1,
        p99: 9.5,
      },
    },
    {
      length: 67,
      m: 7.8986,
      s: 0.08213,
      percentiles: {
        p1: 6.6,
        p3: 6.8,
        p5: 6.9,
        p15: 7.3,
        p25: 7.5,
        p50: 7.9,
        p75: 8.4,
        p85: 8.6,
        p95: 9.1,
        p97: 9.3,
        p99: 9.6,
      },
    },
    {
      length: 67.5,
      m: 8.0132,
      s: 0.08214,
      percentiles: {
        p1: 6.7,
        p3: 6.9,
        p5: 7,
        p15: 7.4,
        p25: 7.6,
        p50: 8,
        p75: 8.5,
        p85: 8.7,
        p95: 9.2,
        p97: 9.4,
        p99: 9.8,
      },
    },
    {
      length: 68,
      m: 8.1272,
      s: 0.08217,
      percentiles: {
        p1: 6.8,
        p3: 7,
        p5: 7.1,
        p15: 7.5,
        p25: 7.7,
        p50: 8.1,
        p75: 8.6,
        p85: 8.9,
        p95: 9.3,
        p97: 9.5,
        p99: 9.9,
      },
    },
    {
      length: 68.5,
      m: 8.241,
      s: 0.08221,
      percentiles: {
        p1: 6.8,
        p3: 7.1,
        p5: 7.2,
        p15: 7.6,
        p25: 7.8,
        p50: 8.2,
        p75: 8.7,
        p85: 9,
        p95: 9.5,
        p97: 9.7,
        p99: 10,
      },
    },
    {
      length: 69,
      m: 8.3547,
      s: 0.08226,
      percentiles: {
        p1: 6.9,
        p3: 7.2,
        p5: 7.3,
        p15: 7.7,
        p25: 7.9,
        p50: 8.4,
        p75: 8.8,
        p85: 9.1,
        p95: 9.6,
        p97: 9.8,
        p99: 10.2,
      },
    },
    {
      length: 69.5,
      m: 8.468,
      s: 0.08231,
      percentiles: {
        p1: 7,
        p3: 7.3,
        p5: 7.4,
        p15: 7.8,
        p25: 8,
        p50: 8.5,
        p75: 9,
        p85: 9.2,
        p95: 9.7,
        p97: 9.9,
        p99: 10.3,
      },
    },
    {
      length: 70,
      m: 8.5808,
      s: 0.08237,
      percentiles: {
        p1: 7.1,
        p3: 7.4,
        p5: 7.5,
        p15: 7.9,
        p25: 8.1,
        p50: 8.6,
        p75: 9.1,
        p85: 9.4,
        p95: 9.9,
        p97: 10.1,
        p99: 10.5,
      },
    },
    {
      length: 70.5,
      m: 8.6927,
      s: 0.08243,
      percentiles: {
        p1: 7.2,
        p3: 7.5,
        p5: 7.6,
        p15: 8,
        p25: 8.2,
        p50: 8.7,
        p75: 9.2,
        p85: 9.5,
        p95: 10,
        p97: 10.2,
        p99: 10.6,
      },
    },
    {
      length: 71,
      m: 8.8036,
      s: 0.0825,
      percentiles: {
        p1: 7.3,
        p3: 7.6,
        p5: 7.7,
        p15: 8.1,
        p25: 8.3,
        p50: 8.8,
        p75: 9.3,
        p85: 9.6,
        p95: 10.1,
        p97: 10.3,
        p99: 10.7,
      },
    },
    {
      length: 71.5,
      m: 8.9135,
      s: 0.08257,
      percentiles: {
        p1: 7.4,
        p3: 7.7,
        p5: 7.8,
        p15: 8.2,
        p25: 8.4,
        p50: 8.9,
        p75: 9.4,
        p85: 9.7,
        p95: 10.2,
        p97: 10.5,
        p99: 10.9,
      },
    },
    {
      length: 72,
      m: 9.0221,
      s: 0.08264,
      percentiles: {
        p1: 7.5,
        p3: 7.8,
        p5: 7.9,
        p15: 8.3,
        p25: 8.5,
        p50: 9,
        p75: 9.5,
        p85: 9.8,
        p95: 10.4,
        p97: 10.6,
        p99: 11,
      },
    },
    {
      length: 72.5,
      m: 9.1292,
      s: 0.08272,
      percentiles: {
        p1: 7.6,
        p3: 7.8,
        p5: 8,
        p15: 8.4,
        p25: 8.6,
        p50: 9.1,
        p75: 9.7,
        p85: 10,
        p95: 10.5,
        p97: 10.7,
        p99: 11.1,
      },
    },
    {
      length: 73,
      m: 9.2347,
      s: 0.08278,
      percentiles: {
        p1: 7.7,
        p3: 7.9,
        p5: 8.1,
        p15: 8.5,
        p25: 8.7,
        p50: 9.2,
        p75: 9.8,
        p85: 10.1,
        p95: 10.6,
        p97: 10.8,
        p99: 11.3,
      },
    },
    {
      length: 73.5,
      m: 9.339,
      s: 0.08285,
      percentiles: {
        p1: 7.8,
        p3: 8,
        p5: 8.2,
        p15: 8.6,
        p25: 8.8,
        p50: 9.3,
        p75: 9.9,
        p85: 10.2,
        p95: 10.7,
        p97: 11,
        p99: 11.4,
      },
    },
    {
      length: 74,
      m: 9.442,
      s: 0.08292,
      percentiles: {
        p1: 7.8,
        p3: 8.1,
        p5: 8.3,
        p15: 8.7,
        p25: 8.9,
        p50: 9.4,
        p75: 10,
        p85: 10.3,
        p95: 10.9,
        p97: 11.1,
        p99: 11.5,
      },
    },
    {
      length: 74.5,
      m: 9.5438,
      s: 0.08298,
      percentiles: {
        p1: 7.9,
        p3: 8.2,
        p5: 8.4,
        p15: 8.8,
        p25: 9,
        p50: 9.5,
        p75: 10.1,
        p85: 10.4,
        p95: 11,
        p97: 11.2,
        p99: 11.7,
      },
    },
    {
      length: 75,
      m: 9.644,
      s: 0.08303,
      percentiles: {
        p1: 8,
        p3: 8.3,
        p5: 8.4,
        p15: 8.9,
        p25: 9.1,
        p50: 9.6,
        p75: 10.2,
        p85: 10.5,
        p95: 11.1,
        p97: 11.3,
        p99: 11.8,
      },
    },
    {
      length: 75.5,
      m: 9.7425,
      s: 0.08308,
      percentiles: {
        p1: 8.1,
        p3: 8.4,
        p5: 8.5,
        p15: 9,
        p25: 9.2,
        p50: 9.7,
        p75: 10.3,
        p85: 10.6,
        p95: 11.2,
        p97: 11.4,
        p99: 11.9,
      },
    },
    {
      length: 76,
      m: 9.8392,
      s: 0.08312,
      percentiles: {
        p1: 8.2,
        p3: 8.5,
        p5: 8.6,
        p15: 9,
        p25: 9.3,
        p50: 9.8,
        p75: 10.4,
        p85: 10.7,
        p95: 11.3,
        p97: 11.6,
        p99: 12,
      },
    },
    {
      length: 76.5,
      m: 9.9341,
      s: 0.08315,
      percentiles: {
        p1: 8.2,
        p3: 8.5,
        p5: 8.7,
        p15: 9.1,
        p25: 9.4,
        p50: 9.9,
        p75: 10.5,
        p85: 10.8,
        p95: 11.4,
        p97: 11.7,
        p99: 12.1,
      },
    },
    {
      length: 77,
      m: 10.0274,
      s: 0.08317,
      percentiles: {
        p1: 8.3,
        p3: 8.6,
        p5: 8.8,
        p15: 9.2,
        p25: 9.5,
        p50: 10,
        p75: 10.6,
        p85: 10.9,
        p95: 11.5,
        p97: 11.8,
        p99: 12.3,
      },
    },
    {
      length: 77.5,
      m: 10.1194,
      s: 0.08318,
      percentiles: {
        p1: 8.4,
        p3: 8.7,
        p5: 8.9,
        p15: 9.3,
        p25: 9.6,
        p50: 10.1,
        p75: 10.7,
        p85: 11,
        p95: 11.6,
        p97: 11.9,
        p99: 12.4,
      },
    },
    {
      length: 78,
      m: 10.2105,
      s: 0.08317,
      percentiles: {
        p1: 8.5,
        p3: 8.8,
        p5: 8.9,
        p15: 9.4,
        p25: 9.7,
        p50: 10.2,
        p75: 10.8,
        p85: 11.1,
        p95: 11.7,
        p97: 12,
        p99: 12.5,
      },
    },
    {
      length: 78.5,
      m: 10.3012,
      s: 0.08315,
      percentiles: {
        p1: 8.5,
        p3: 8.8,
        p5: 9,
        p15: 9.5,
        p25: 9.7,
        p50: 10.3,
        p75: 10.9,
        p85: 11.2,
        p95: 11.9,
        p97: 12.1,
        p99: 12.6,
      },
    },
    {
      length: 79,
      m: 10.3923,
      s: 0.08311,
      percentiles: {
        p1: 8.6,
        p3: 8.9,
        p5: 9.1,
        p15: 9.5,
        p25: 9.8,
        p50: 10.4,
        p75: 11,
        p85: 11.3,
        p95: 12,
        p97: 12.2,
        p99: 12.7,
      },
    },
    {
      length: 79.5,
      m: 10.4845,
      s: 0.08305,
      percentiles: {
        p1: 8.7,
        p3: 9,
        p5: 9.2,
        p15: 9.6,
        p25: 9.9,
        p50: 10.5,
        p75: 11.1,
        p85: 11.4,
        p95: 12.1,
        p97: 12.3,
        p99: 12.8,
      },
    },
    {
      length: 80,
      m: 10.5781,
      s: 0.08298,
      percentiles: {
        p1: 8.8,
        p3: 9.1,
        p5: 9.3,
        p15: 9.7,
        p25: 10,
        p50: 10.6,
        p75: 11.2,
        p85: 11.5,
        p95: 12.2,
        p97: 12.4,
        p99: 12.9,
      },
    },
    {
      length: 80.5,
      m: 10.6737,
      s: 0.0829,
      percentiles: {
        p1: 8.9,
        p3: 9.2,
        p5: 9.3,
        p15: 9.8,
        p25: 10.1,
        p50: 10.7,
        p75: 11.3,
        p85: 11.6,
        p95: 12.3,
        p97: 12.5,
        p99: 13,
      },
    },
    {
      length: 81,
      m: 10.7718,
      s: 0.08279,
      percentiles: {
        p1: 8.9,
        p3: 9.3,
        p5: 9.4,
        p15: 9.9,
        p25: 10.2,
        p50: 10.8,
        p75: 11.4,
        p85: 11.8,
        p95: 12.4,
        p97: 12.6,
        p99: 13.1,
      },
    },
    {
      length: 81.5,
      m: 10.8728,
      s: 0.08268,
      percentiles: {
        p1: 9,
        p3: 9.3,
        p5: 9.5,
        p15: 10,
        p25: 10.3,
        p50: 10.9,
        p75: 11.5,
        p85: 11.9,
        p95: 12.5,
        p97: 12.8,
        p99: 13.3,
      },
    },
    {
      length: 82,
      m: 10.9772,
      s: 0.08255,
      percentiles: {
        p1: 9.1,
        p3: 9.4,
        p5: 9.6,
        p15: 10.1,
        p25: 10.4,
        p50: 11,
        p75: 11.6,
        p85: 12,
        p95: 12.6,
        p97: 12.9,
        p99: 13.4,
      },
    },
    {
      length: 82.5,
      m: 11.0851,
      s: 0.08241,
      percentiles: {
        p1: 9.2,
        p3: 9.5,
        p5: 9.7,
        p15: 10.2,
        p25: 10.5,
        p50: 11.1,
        p75: 11.7,
        p85: 12.1,
        p95: 12.7,
        p97: 13,
        p99: 13.5,
      },
    },
    {
      length: 83,
      m: 11.1966,
      s: 0.08225,
      percentiles: {
        p1: 9.3,
        p3: 9.6,
        p5: 9.8,
        p15: 10.3,
        p25: 10.6,
        p50: 11.2,
        p75: 11.8,
        p85: 12.2,
        p95: 12.9,
        p97: 13.1,
        p99: 13.6,
      },
    },
    {
      length: 83.5,
      m: 11.3114,
      s: 0.08209,
      percentiles: {
        p1: 9.4,
        p3: 9.7,
        p5: 9.9,
        p15: 10.4,
        p25: 10.7,
        p50: 11.3,
        p75: 12,
        p85: 12.3,
        p95: 13,
        p97: 13.3,
        p99: 13.8,
      },
    },
    {
      length: 84,
      m: 11.429,
      s: 0.08191,
      percentiles: {
        p1: 9.5,
        p3: 9.8,
        p5: 10,
        p15: 10.5,
        p25: 10.8,
        p50: 11.4,
        p75: 12.1,
        p85: 12.5,
        p95: 13.1,
        p97: 13.4,
        p99: 13.9,
      },
    },
    {
      length: 84.5,
      m: 11.549,
      s: 0.08174,
      percentiles: {
        p1: 9.6,
        p3: 9.9,
        p5: 10.1,
        p15: 10.6,
        p25: 10.9,
        p50: 11.5,
        p75: 12.2,
        p85: 12.6,
        p95: 13.3,
        p97: 13.5,
        p99: 14.1,
      },
    },
    {
      length: 85,
      m: 11.6707,
      s: 0.08156,
      percentiles: {
        p1: 9.7,
        p3: 10.1,
        p5: 10.2,
        p15: 10.7,
        p25: 11.1,
        p50: 11.7,
        p75: 12.3,
        p85: 12.7,
        p95: 13.4,
        p97: 13.7,
        p99: 14.2,
      },
    },
    {
      length: 85.5,
      m: 11.7937,
      s: 0.08138,
      percentiles: {
        p1: 9.8,
        p3: 10.2,
        p5: 10.3,
        p15: 10.9,
        p25: 11.2,
        p50: 11.8,
        p75: 12.5,
        p85: 12.8,
        p95: 13.5,
        p97: 13.8,
        p99: 14.3,
      },
    },
    {
      length: 86,
      m: 11.9173,
      s: 0.08121,
      percentiles: {
        p1: 9.9,
        p3: 10.3,
        p5: 10.5,
        p15: 11,
        p25: 11.3,
        p50: 11.9,
        p75: 12.6,
        p85: 13,
        p95: 13.7,
        p97: 13.9,
        p99: 14.5,
      },
    },
    {
      length: 86.5,
      m: 12.0411,
      s: 0.08105,
      percentiles: {
        p1: 10,
        p3: 10.4,
        p5: 10.6,
        p15: 11.1,
        p25: 11.4,
        p50: 12,
        p75: 12.7,
        p85: 13.1,
        p95: 13.8,
        p97: 14.1,
        p99: 14.6,
      },
    },
    {
      length: 87,
      m: 12.1645,
      s: 0.0809,
      percentiles: {
        p1: 10.1,
        p3: 10.5,
        p5: 10.7,
        p15: 11.2,
        p25: 11.5,
        p50: 12.2,
        p75: 12.9,
        p85: 13.2,
        p95: 13.9,
        p97: 14.2,
        p99: 14.8,
      },
    },
    {
      length: 87.5,
      m: 12.2871,
      s: 0.08076,
      percentiles: {
        p1: 10.2,
        p3: 10.6,
        p5: 10.8,
        p15: 11.3,
        p25: 11.6,
        p50: 12.3,
        p75: 13,
        p85: 13.4,
        p95: 14.1,
        p97: 14.4,
        p99: 14.9,
      },
    },
    {
      length: 88,
      m: 12.4089,
      s: 0.08064,
      percentiles: {
        p1: 10.3,
        p3: 10.7,
        p5: 10.9,
        p15: 11.4,
        p25: 11.8,
        p50: 12.4,
        p75: 13.1,
        p85: 13.5,
        p95: 14.2,
        p97: 14.5,
        p99: 15.1,
      },
    },
    {
      length: 88.5,
      m: 12.5298,
      s: 0.08054,
      percentiles: {
        p1: 10.5,
        p3: 10.8,
        p5: 11,
        p15: 11.5,
        p25: 11.9,
        p50: 12.5,
        p75: 13.2,
        p85: 13.6,
        p95: 14.4,
        p97: 14.6,
        p99: 15.2,
      },
    },
    {
      length: 89,
      m: 12.6495,
      s: 0.08045,
      percentiles: {
        p1: 10.6,
        p3: 10.9,
        p5: 11.1,
        p15: 11.7,
        p25: 12,
        p50: 12.6,
        p75: 13.4,
        p85: 13.8,
        p95: 14.5,
        p97: 14.8,
        p99: 15.4,
      },
    },
    {
      length: 89.5,
      m: 12.7683,
      s: 0.08038,
      percentiles: {
        p1: 10.7,
        p3: 11,
        p5: 11.2,
        p15: 11.8,
        p25: 12.1,
        p50: 12.8,
        p75: 13.5,
        p85: 13.9,
        p95: 14.6,
        p97: 14.9,
        p99: 15.5,
      },
    },
    {
      length: 90,
      m: 12.8864,
      s: 0.08032,
      percentiles: {
        p1: 10.8,
        p3: 11.1,
        p5: 11.3,
        p15: 11.9,
        p25: 12.2,
        p50: 12.9,
        p75: 13.6,
        p85: 14,
        p95: 14.8,
        p97: 15.1,
        p99: 15.6,
      },
    },
    {
      length: 90.5,
      m: 13.0038,
      s: 0.08028,
      percentiles: {
        p1: 10.9,
        p3: 11.2,
        p5: 11.4,
        p15: 12,
        p25: 12.3,
        p50: 13,
        p75: 13.7,
        p85: 14.1,
        p95: 14.9,
        p97: 15.2,
        p99: 15.8,
      },
    },
    {
      length: 91,
      m: 13.1209,
      s: 0.08025,
      percentiles: {
        p1: 11,
        p3: 11.3,
        p5: 11.5,
        p15: 12.1,
        p25: 12.4,
        p50: 13.1,
        p75: 13.9,
        p85: 14.3,
        p95: 15,
        p97: 15.3,
        p99: 15.9,
      },
    },
    {
      length: 91.5,
      m: 13.2376,
      s: 0.08024,
      percentiles: {
        p1: 11,
        p3: 11.4,
        p5: 11.6,
        p15: 12.2,
        p25: 12.5,
        p50: 13.2,
        p75: 14,
        p85: 14.4,
        p95: 15.2,
        p97: 15.5,
        p99: 16.1,
      },
    },
    {
      length: 92,
      m: 13.3541,
      s: 0.08025,
      percentiles: {
        p1: 11.1,
        p3: 11.5,
        p5: 11.7,
        p15: 12.3,
        p25: 12.7,
        p50: 13.4,
        p75: 14.1,
        p85: 14.5,
        p95: 15.3,
        p97: 15.6,
        p99: 16.2,
      },
    },
    {
      length: 92.5,
      m: 13.4705,
      s: 0.08027,
      percentiles: {
        p1: 11.2,
        p3: 11.6,
        p5: 11.8,
        p15: 12.4,
        p25: 12.8,
        p50: 13.5,
        p75: 14.2,
        p85: 14.7,
        p95: 15.4,
        p97: 15.7,
        p99: 16.3,
      },
    },
    {
      length: 93,
      m: 13.587,
      s: 0.08031,
      percentiles: {
        p1: 11.3,
        p3: 11.7,
        p5: 11.9,
        p15: 12.5,
        p25: 12.9,
        p50: 13.6,
        p75: 14.4,
        p85: 14.8,
        p95: 15.6,
        p97: 15.9,
        p99: 16.5,
      },
    },
    {
      length: 93.5,
      m: 13.7041,
      s: 0.08036,
      percentiles: {
        p1: 11.4,
        p3: 11.8,
        p5: 12,
        p15: 12.6,
        p25: 13,
        p50: 13.7,
        p75: 14.5,
        p85: 14.9,
        p95: 15.7,
        p97: 16,
        p99: 16.6,
      },
    },
    {
      length: 94,
      m: 13.8217,
      s: 0.08043,
      percentiles: {
        p1: 11.5,
        p3: 11.9,
        p5: 12.1,
        p15: 12.7,
        p25: 13.1,
        p50: 13.8,
        p75: 14.6,
        p85: 15,
        p95: 15.8,
        p97: 16.1,
        p99: 16.8,
      },
    },
    {
      length: 94.5,
      m: 13.9403,
      s: 0.08051,
      percentiles: {
        p1: 11.6,
        p3: 12,
        p5: 12.2,
        p15: 12.8,
        p25: 13.2,
        p50: 13.9,
        p75: 14.7,
        p85: 15.2,
        p95: 16,
        p97: 16.3,
        p99: 16.9,
      },
    },
    {
      length: 95,
      m: 14.06,
      s: 0.0806,
      percentiles: {
        p1: 11.7,
        p3: 12.1,
        p5: 12.4,
        p15: 12.9,
        p25: 13.3,
        p50: 14.1,
        p75: 14.9,
        p85: 15.3,
        p95: 16.1,
        p97: 16.4,
        p99: 17.1,
      },
    },
    {
      length: 95.5,
      m: 14.1811,
      s: 0.08071,
      percentiles: {
        p1: 11.8,
        p3: 12.2,
        p5: 12.5,
        p15: 13.1,
        p25: 13.4,
        p50: 14.2,
        p75: 15,
        p85: 15.4,
        p95: 16.2,
        p97: 16.6,
        p99: 17.2,
      },
    },
    {
      length: 96,
      m: 14.3037,
      s: 0.08083,
      percentiles: {
        p1: 11.9,
        p3: 12.3,
        p5: 12.6,
        p15: 13.2,
        p25: 13.6,
        p50: 14.3,
        p75: 15.1,
        p85: 15.6,
        p95: 16.4,
        p97: 16.7,
        p99: 17.4,
      },
    },
    {
      length: 96.5,
      m: 14.4282,
      s: 0.08097,
      percentiles: {
        p1: 12,
        p3: 12.4,
        p5: 12.7,
        p15: 13.3,
        p25: 13.7,
        p50: 14.4,
        p75: 15.2,
        p85: 15.7,
        p95: 16.5,
        p97: 16.9,
        p99: 17.5,
      },
    },
    {
      length: 97,
      m: 14.5547,
      s: 0.08112,
      percentiles: {
        p1: 12.1,
        p3: 12.5,
        p5: 12.8,
        p15: 13.4,
        p25: 13.8,
        p50: 14.6,
        p75: 15.4,
        p85: 15.9,
        p95: 16.7,
        p97: 17,
        p99: 17.7,
      },
    },
    {
      length: 97.5,
      m: 14.6832,
      s: 0.08129,
      percentiles: {
        p1: 12.2,
        p3: 12.7,
        p5: 12.9,
        p15: 13.5,
        p25: 13.9,
        p50: 14.7,
        p75: 15.5,
        p85: 16,
        p95: 16.8,
        p97: 17.2,
        p99: 17.9,
      },
    },
    {
      length: 98,
      m: 14.814,
      s: 0.08146,
      percentiles: {
        p1: 12.3,
        p3: 12.8,
        p5: 13,
        p15: 13.6,
        p25: 14,
        p50: 14.8,
        p75: 15.7,
        p85: 16.1,
        p95: 17,
        p97: 17.3,
        p99: 18,
      },
    },
    {
      length: 98.5,
      m: 14.9468,
      s: 0.08165,
      percentiles: {
        p1: 12.4,
        p3: 12.9,
        p5: 13.1,
        p15: 13.8,
        p25: 14.2,
        p50: 14.9,
        p75: 15.8,
        p85: 16.3,
        p95: 17.2,
        p97: 17.5,
        p99: 18.2,
      },
    },
    {
      length: 99,
      m: 15.0818,
      s: 0.08185,
      percentiles: {
        p1: 12.5,
        p3: 13,
        p5: 13.2,
        p15: 13.9,
        p25: 14.3,
        p50: 15.1,
        p75: 15.9,
        p85: 16.4,
        p95: 17.3,
        p97: 17.7,
        p99: 18.4,
      },
    },
    {
      length: 99.5,
      m: 15.2187,
      s: 0.08206,
      percentiles: {
        p1: 12.7,
        p3: 13.1,
        p5: 13.3,
        p15: 14,
        p25: 14.4,
        p50: 15.2,
        p75: 16.1,
        p85: 16.6,
        p95: 17.5,
        p97: 17.8,
        p99: 18.5,
      },
    },
    {
      length: 100,
      m: 15.3576,
      s: 0.08229,
      percentiles: {
        p1: 12.8,
        p3: 13.2,
        p5: 13.5,
        p15: 14.1,
        p25: 14.5,
        p50: 15.4,
        p75: 16.2,
        p85: 16.7,
        p95: 17.6,
        p97: 18,
        p99: 18.7,
      },
    },
    {
      length: 100.5,
      m: 15.4985,
      s: 0.08252,
      percentiles: {
        p1: 12.9,
        p3: 13.3,
        p5: 13.6,
        p15: 14.2,
        p25: 14.7,
        p50: 15.5,
        p75: 16.4,
        p85: 16.9,
        p95: 17.8,
        p97: 18.2,
        p99: 18.9,
      },
    },
    {
      length: 101,
      m: 15.6412,
      s: 0.08277,
      percentiles: {
        p1: 13,
        p3: 13.4,
        p5: 13.7,
        p15: 14.4,
        p25: 14.8,
        p50: 15.6,
        p75: 16.5,
        p85: 17.1,
        p95: 18,
        p97: 18.4,
        p99: 19.1,
      },
    },
    {
      length: 101.5,
      m: 15.7857,
      s: 0.08302,
      percentiles: {
        p1: 13.1,
        p3: 13.6,
        p5: 13.8,
        p15: 14.5,
        p25: 14.9,
        p50: 15.8,
        p75: 16.7,
        p85: 17.2,
        p95: 18.2,
        p97: 18.5,
        p99: 19.3,
      },
    },
    {
      length: 102,
      m: 15.932,
      s: 0.08328,
      percentiles: {
        p1: 13.2,
        p3: 13.7,
        p5: 13.9,
        p15: 14.6,
        p25: 15.1,
        p50: 15.9,
        p75: 16.9,
        p85: 17.4,
        p95: 18.3,
        p97: 18.7,
        p99: 19.5,
      },
    },
    {
      length: 102.5,
      m: 16.0801,
      s: 0.08354,
      percentiles: {
        p1: 13.3,
        p3: 13.8,
        p5: 14.1,
        p15: 14.8,
        p25: 15.2,
        p50: 16.1,
        p75: 17,
        p85: 17.6,
        p95: 18.5,
        p97: 18.9,
        p99: 19.7,
      },
    },
    {
      length: 103,
      m: 16.2298,
      s: 0.08381,
      percentiles: {
        p1: 13.4,
        p3: 13.9,
        p5: 14.2,
        p15: 14.9,
        p25: 15.3,
        p50: 16.2,
        p75: 17.2,
        p85: 17.7,
        p95: 18.7,
        p97: 19.1,
        p99: 19.9,
      },
    },
    {
      length: 103.5,
      m: 16.3812,
      s: 0.08408,
      percentiles: {
        p1: 13.6,
        p3: 14,
        p5: 14.3,
        p15: 15,
        p25: 15.5,
        p50: 16.4,
        p75: 17.3,
        p85: 17.9,
        p95: 18.9,
        p97: 19.3,
        p99: 20.1,
      },
    },
    {
      length: 104,
      m: 16.5342,
      s: 0.08436,
      percentiles: {
        p1: 13.7,
        p3: 14.2,
        p5: 14.4,
        p15: 15.2,
        p25: 15.6,
        p50: 16.5,
        p75: 17.5,
        p85: 18.1,
        p95: 19.1,
        p97: 19.5,
        p99: 20.3,
      },
    },
    {
      length: 104.5,
      m: 16.6889,
      s: 0.08464,
      percentiles: {
        p1: 13.8,
        p3: 14.3,
        p5: 14.6,
        p15: 15.3,
        p25: 15.8,
        p50: 16.7,
        p75: 17.7,
        p85: 18.2,
        p95: 19.2,
        p97: 19.7,
        p99: 20.5,
      },
    },
    {
      length: 105,
      m: 16.8454,
      s: 0.08493,
      percentiles: {
        p1: 13.9,
        p3: 14.4,
        p5: 14.7,
        p15: 15.4,
        p25: 15.9,
        p50: 16.8,
        p75: 17.8,
        p85: 18.4,
        p95: 19.4,
        p97: 19.9,
        p99: 20.7,
      },
    },
    {
      length: 105.5,
      m: 17.0036,
      s: 0.08521,
      percentiles: {
        p1: 14,
        p3: 14.5,
        p5: 14.8,
        p15: 15.6,
        p25: 16.1,
        p50: 17,
        p75: 18,
        p85: 18.6,
        p95: 19.6,
        p97: 20.1,
        p99: 20.9,
      },
    },
    {
      length: 106,
      m: 17.1637,
      s: 0.08551,
      percentiles: {
        p1: 14.2,
        p3: 14.7,
        p5: 15,
        p15: 15.7,
        p25: 16.2,
        p50: 17.2,
        p75: 18.2,
        p85: 18.8,
        p95: 19.8,
        p97: 20.3,
        p99: 21.1,
      },
    },
    {
      length: 106.5,
      m: 17.3256,
      s: 0.0858,
      percentiles: {
        p1: 14.3,
        p3: 14.8,
        p5: 15.1,
        p15: 15.9,
        p25: 16.4,
        p50: 17.3,
        p75: 18.4,
        p85: 19,
        p95: 20,
        p97: 20.5,
        p99: 21.3,
      },
    },
    {
      length: 107,
      m: 17.4894,
      s: 0.08611,
      percentiles: {
        p1: 14.4,
        p3: 14.9,
        p5: 15.2,
        p15: 16,
        p25: 16.5,
        p50: 17.5,
        p75: 18.5,
        p85: 19.1,
        p95: 20.2,
        p97: 20.7,
        p99: 21.5,
      },
    },
    {
      length: 107.5,
      m: 17.655,
      s: 0.08641,
      percentiles: {
        p1: 14.5,
        p3: 15.1,
        p5: 15.4,
        p15: 16.2,
        p25: 16.7,
        p50: 17.7,
        p75: 18.7,
        p85: 19.3,
        p95: 20.4,
        p97: 20.9,
        p99: 21.7,
      },
    },
    {
      length: 108,
      m: 17.8226,
      s: 0.08673,
      percentiles: {
        p1: 14.7,
        p3: 15.2,
        p5: 15.5,
        p15: 16.3,
        p25: 16.8,
        p50: 17.8,
        p75: 18.9,
        p85: 19.5,
        p95: 20.6,
        p97: 21.1,
        p99: 22,
      },
    },
    {
      length: 108.5,
      m: 17.9924,
      s: 0.08704,
      percentiles: {
        p1: 14.8,
        p3: 15.3,
        p5: 15.6,
        p15: 16.5,
        p25: 17,
        p50: 18,
        p75: 19.1,
        p85: 19.7,
        p95: 20.8,
        p97: 21.3,
        p99: 22.2,
      },
    },
    {
      length: 109,
      m: 18.1645,
      s: 0.08736,
      percentiles: {
        p1: 14.9,
        p3: 15.5,
        p5: 15.8,
        p15: 16.6,
        p25: 17.1,
        p50: 18.2,
        p75: 19.3,
        p85: 19.9,
        p95: 21.1,
        p97: 21.5,
        p99: 22.4,
      },
    },
    {
      length: 109.5,
      m: 18.339,
      s: 0.08768,
      percentiles: {
        p1: 15.1,
        p3: 15.6,
        p5: 15.9,
        p15: 16.8,
        p25: 17.3,
        p50: 18.3,
        p75: 19.5,
        p85: 20.1,
        p95: 21.3,
        p97: 21.7,
        p99: 22.7,
      },
    },
    {
      length: 110,
      m: 18.5158,
      s: 0.088,
      percentiles: {
        p1: 15.2,
        p3: 15.8,
        p5: 16.1,
        p15: 16.9,
        p25: 17.5,
        p50: 18.5,
        p75: 19.7,
        p85: 20.3,
        p95: 21.5,
        p97: 22,
        p99: 22.9,
      },
    },
    {
      length: 110.5,
      m: 18.6948,
      s: 0.08832,
      percentiles: {
        p1: 15.3,
        p3: 15.9,
        p5: 16.2,
        p15: 17.1,
        p25: 17.6,
        p50: 18.7,
        p75: 19.9,
        p85: 20.5,
        p95: 21.7,
        p97: 22.2,
        p99: 23.1,
      },
    },
    {
      length: 111,
      m: 18.8759,
      s: 0.08864,
      percentiles: {
        p1: 15.5,
        p3: 16.1,
        p5: 16.4,
        p15: 17.2,
        p25: 17.8,
        p50: 18.9,
        p75: 20.1,
        p85: 20.7,
        p95: 21.9,
        p97: 22.4,
        p99: 23.4,
      },
    },
    {
      length: 111.5,
      m: 19.059,
      s: 0.08896,
      percentiles: {
        p1: 15.6,
        p3: 16.2,
        p5: 16.5,
        p15: 17.4,
        p25: 18,
        p50: 19.1,
        p75: 20.3,
        p85: 20.9,
        p95: 22.1,
        p97: 22.6,
        p99: 23.6,
      },
    },
    {
      length: 112,
      m: 19.2439,
      s: 0.08928,
      percentiles: {
        p1: 15.7,
        p3: 16.3,
        p5: 16.7,
        p15: 17.6,
        p25: 18.1,
        p50: 19.2,
        p75: 20.5,
        p85: 21.1,
        p95: 22.4,
        p97: 22.9,
        p99: 23.9,
      },
    },
    {
      length: 112.5,
      m: 19.4304,
      s: 0.0896,
      percentiles: {
        p1: 15.9,
        p3: 16.5,
        p5: 16.8,
        p15: 17.7,
        p25: 18.3,
        p50: 19.4,
        p75: 20.7,
        p85: 21.4,
        p95: 22.6,
        p97: 23.1,
        p99: 24.1,
      },
    },
    {
      length: 113,
      m: 19.6185,
      s: 0.08991,
      percentiles: {
        p1: 16,
        p3: 16.6,
        p5: 17,
        p15: 17.9,
        p25: 18.5,
        p50: 19.6,
        p75: 20.9,
        p85: 21.6,
        p95: 22.8,
        p97: 23.4,
        p99: 24.4,
      },
    },
    {
      length: 113.5,
      m: 19.8081,
      s: 0.09022,
      percentiles: {
        p1: 16.2,
        p3: 16.8,
        p5: 17.1,
        p15: 18.1,
        p25: 18.7,
        p50: 19.8,
        p75: 21.1,
        p85: 21.8,
        p95: 23.1,
        p97: 23.6,
        p99: 24.6,
      },
    },
    {
      length: 114,
      m: 19.999,
      s: 0.09054,
      percentiles: {
        p1: 16.3,
        p3: 17,
        p5: 17.3,
        p15: 18.2,
        p25: 18.8,
        p50: 20,
        p75: 21.3,
        p85: 22,
        p95: 23.3,
        p97: 23.8,
        p99: 24.9,
      },
    },
    {
      length: 114.5,
      m: 20.1912,
      s: 0.09085,
      percentiles: {
        p1: 16.5,
        p3: 17.1,
        p5: 17.5,
        p15: 18.4,
        p25: 19,
        p50: 20.2,
        p75: 21.5,
        p85: 22.2,
        p95: 23.5,
        p97: 24.1,
        p99: 25.2,
      },
    },
    {
      length: 115,
      m: 20.3846,
      s: 0.09116,
      percentiles: {
        p1: 16.6,
        p3: 17.3,
        p5: 17.6,
        p15: 18.6,
        p25: 19.2,
        p50: 20.4,
        p75: 21.7,
        p85: 22.4,
        p95: 23.8,
        p97: 24.3,
        p99: 25.4,
      },
    },
    {
      length: 115.5,
      m: 20.5789,
      s: 0.09147,
      percentiles: {
        p1: 16.8,
        p3: 17.4,
        p5: 17.8,
        p15: 18.7,
        p25: 19.4,
        p50: 20.6,
        p75: 21.9,
        p85: 22.7,
        p95: 24,
        p97: 24.6,
        p99: 25.7,
      },
    },
    {
      length: 116,
      m: 20.7741,
      s: 0.09177,
      percentiles: {
        p1: 16.9,
        p3: 17.6,
        p5: 17.9,
        p15: 18.9,
        p25: 19.5,
        p50: 20.8,
        p75: 22.1,
        p85: 22.9,
        p95: 24.3,
        p97: 24.8,
        p99: 25.9,
      },
    },
    {
      length: 116.5,
      m: 20.97,
      s: 0.09208,
      percentiles: {
        p1: 17.1,
        p3: 17.7,
        p5: 18.1,
        p15: 19.1,
        p25: 19.7,
        p50: 21,
        p75: 22.3,
        p85: 23.1,
        p95: 24.5,
        p97: 25.1,
        p99: 26.2,
      },
    },
    {
      length: 117,
      m: 21.1666,
      s: 0.09239,
      percentiles: {
        p1: 17.2,
        p3: 17.9,
        p5: 18.3,
        p15: 19.3,
        p25: 19.9,
        p50: 21.2,
        p75: 22.5,
        p85: 23.3,
        p95: 24.7,
        p97: 25.3,
        p99: 26.5,
      },
    },
    {
      length: 117.5,
      m: 21.3636,
      s: 0.0927,
      percentiles: {
        p1: 17.4,
        p3: 18,
        p5: 18.4,
        p15: 19.4,
        p25: 20.1,
        p50: 21.4,
        p75: 22.8,
        p85: 23.6,
        p95: 25,
        p97: 25.6,
        p99: 26.7,
      },
    },
    {
      length: 118,
      m: 21.5611,
      s: 0.093,
      percentiles: {
        p1: 17.5,
        p3: 18.2,
        p5: 18.6,
        p15: 19.6,
        p25: 20.3,
        p50: 21.6,
        p75: 23,
        p85: 23.8,
        p95: 25.2,
        p97: 25.8,
        p99: 27,
      },
    },
    {
      length: 118.5,
      m: 21.7588,
      s: 0.09331,
      percentiles: {
        p1: 17.7,
        p3: 18.4,
        p5: 18.7,
        p15: 19.8,
        p25: 20.4,
        p50: 21.8,
        p75: 23.2,
        p85: 24,
        p95: 25.5,
        p97: 26.1,
        p99: 27.3,
      },
    },
    {
      length: 119,
      m: 21.9568,
      s: 0.09362,
      percentiles: {
        p1: 17.8,
        p3: 18.5,
        p5: 18.9,
        p15: 20,
        p25: 20.6,
        p50: 22,
        p75: 23.4,
        p85: 24.2,
        p95: 25.7,
        p97: 26.3,
        p99: 27.5,
      },
    },
    {
      length: 119.5,
      m: 22.1549,
      s: 0.09393,
      percentiles: {
        p1: 17.9,
        p3: 18.7,
        p5: 19.1,
        p15: 20.1,
        p25: 20.8,
        p50: 22.2,
        p75: 23.6,
        p85: 24.5,
        p95: 26,
        p97: 26.6,
        p99: 27.8,
      },
    },
    {
      length: 120,
      m: 22.353,
      s: 0.09424,
      percentiles: {
        p1: 18.1,
        p3: 18.8,
        p5: 19.2,
        p15: 20.3,
        p25: 21,
        p50: 22.4,
        p75: 23.8,
        p85: 24.7,
        p95: 26.2,
        p97: 26.8,
        p99: 28.1,
      },
    },
  ],
};
